// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardTemplate\ApiTopicCardTemplate.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthAmenityType, BerthAmenityTypeData, BerthAmenityTypeOptions } from 'data/models/BerthAmenityType';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { TopicCardTemplateAttachment, TopicCardTemplateAttachmentData, TopicCardTemplateAttachmentOptions } from 'data/models/TopicCardTemplateAttachment';
import { TopicCardTemplateOption, TopicCardTemplateOptionData, TopicCardTemplateOptionOptions } from 'data/models/TopicCardTemplateOption';
import { TopicCardTemplateTimeEntry, TopicCardTemplateTimeEntryData, TopicCardTemplateTimeEntryOptions } from 'data/models/TopicCardTemplateTimeEntry';
import { TopicCardTemplateUserAssignment, TopicCardTemplateUserAssignmentData, TopicCardTemplateUserAssignmentOptions } from 'data/models/TopicCardTemplateUserAssignment';
import { TopicCardQuestionType } from 'server/enums/TopicCardQuestionType';

// TopicCardTemplateData is the class that TopicCardTemplate serializes to/from
export interface TopicCardTemplateData {
    Id : number;
    Url : string | null;
	
    AmenityType : BerthAmenityTypeData | null;
    AmenityTypeId : number | null;
    Attachments : TopicCardTemplateAttachmentData[] | null;
    AttachmentsUrl : string | null;
    Options : TopicCardTemplateOptionData[] | null;
    OptionsUrl : string | null;
    Organization : OrganizationData | null;
    OrganizationId : number;
    People : TopicCardTemplateUserAssignmentData[] | null;
	
    Active : boolean;
    Guid : /* GUID */ string;
    PeopleUrlBase : string | null;
    Question : string;
    QuestionType : TopicCardQuestionType;
    Remarks : string | null;
    TimeEntry : TopicCardTemplateTimeEntryData;
    Title : string;
}

// TopicCardTemplateOptions is the class which may be passed to the TopicCardTemplate constructor to define optional initial data values
export interface TopicCardTemplateOptions {
    Id : number;
    Url? : string | null;
	
    AmenityType? : BerthAmenityTypeOptions | null;
    AmenityTypeId? : number | null;
    Attachments? : TopicCardTemplateAttachmentOptions[] | null;
    AttachmentsUrl? : string | null;
    Options? : TopicCardTemplateOptionOptions[] | null;
    OptionsUrl? : string | null;
    Organization? : OrganizationOptions | null;
    OrganizationId? : number;
    People? : TopicCardTemplateUserAssignmentOptions[] | null;
	
    Active? : boolean;
    Guid? : /* GUID */ string;
    PeopleUrlBase? : string | null;
    Question? : string;
    QuestionType? : TopicCardQuestionType;
    Remarks? : string | null;
    TimeEntry? : TopicCardTemplateTimeEntryOptions;
    Title? : string;
}

export class TopicCardTemplate {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public AmenityType : DataSignal<BerthAmenityType | null>;
    public AmenityTypeId : DataSignal<number | null>;
    public Attachments : SDataArray<TopicCardTemplateAttachment>;
    public AttachmentsUrl : DataSignal<string | null>;
    public Options : SDataArray<TopicCardTemplateOption>;
    public OptionsUrl : DataSignal<string | null>;
    public Organization : DataSignal<Organization | null>;
    public OrganizationId : DataSignal<number>;
    public People : SDataArray<TopicCardTemplateUserAssignment>;
	
    public Active : DataSignal<boolean>;
    public Guid : DataSignal<string>;
    public PeopleUrlBase : DataSignal<string | null>;
    public Question : DataSignal<string>;
    public QuestionType : DataSignal<TopicCardQuestionType>;
    public Remarks : DataSignal<string | null>;
    public TimeEntry : TopicCardTemplateTimeEntry;
    public Title : DataSignal<string>;

    constructor();
    constructor(data : TopicCardTemplateOptions);
    constructor(data: TopicCardTemplateOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.AmenityType = S.value<BerthAmenityType | null>(null);
        this.AmenityTypeId = jsonableObservable(S.value<number | null>(data && data.AmenityTypeId !== undefined ? data.AmenityTypeId : null));
        this.Attachments = SArray<TopicCardTemplateAttachment>([]);
        this.AttachmentsUrl = jsonableObservable(S.value<string | null>(data && data.AttachmentsUrl !== undefined ? data.AttachmentsUrl : null));
        this.Options = SArray<TopicCardTemplateOption>([]);
        this.OptionsUrl = jsonableObservable(S.value<string | null>(data && data.OptionsUrl !== undefined ? data.OptionsUrl : null));
        this.Organization = S.value<Organization | null>(null);
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.People = SArray<TopicCardTemplateUserAssignment>([]);
	    
        this.Active = jsonableObservable(S.value<boolean>(data && data.Active !== undefined ? data.Active : false));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.PeopleUrlBase = jsonableObservable(S.value<string | null>(data && data.PeopleUrlBase !== undefined ? data.PeopleUrlBase : null));
        this.Question = jsonableObservable(S.value<string>(data && data.Question !== undefined ? data.Question : ''));
        this.QuestionType = jsonableObservable(S.value<TopicCardQuestionType>(data && data.QuestionType !== undefined ? data.QuestionType : 0));
        this.Remarks = jsonableObservable(S.value<string | null>(data && data.Remarks !== undefined ? data.Remarks : null));
        this.TimeEntry = data && data.TimeEntry !== undefined ? new TopicCardTemplateTimeEntry(data.TimeEntry) : new TopicCardTemplateTimeEntry();
        this.Title = jsonableObservable(S.value<string>(data && data.Title !== undefined ? data.Title : ''));
    }

    static key(obj : TopicCardTemplate) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardTemplateOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardTemplate, data : TopicCardTemplateOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.AmenityTypeId !== undefined) obj.AmenityTypeId(data.AmenityTypeId);
            if (data.AttachmentsUrl !== undefined) obj.AttachmentsUrl(data.AttachmentsUrl);
            if (data.OptionsUrl !== undefined) obj.OptionsUrl(data.OptionsUrl);
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
            if (data.Active !== undefined) obj.Active(data.Active);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.PeopleUrlBase !== undefined) obj.PeopleUrlBase(data.PeopleUrlBase);
            if (data.Question !== undefined) obj.Question(data.Question);
            if (data.QuestionType !== undefined) obj.QuestionType(data.QuestionType);
            if (data.Remarks !== undefined) obj.Remarks(data.Remarks);
            if (data.TimeEntry !== undefined) TopicCardTemplateTimeEntry.update(obj.TimeEntry, data.TimeEntry);
            if (data.Title !== undefined) obj.Title(data.Title);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardTemplate.ts